import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { HttpClient, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

//FB 6060 SSO Integration
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

import { UtilityService } from './utility.service';

@Injectable()
export class GenericService {
  public __bDashboardControlDisplay: BehaviorSubject<boolean>= new BehaviorSubject(true);
  constructor(
    private http: HttpClient,
    private oRouter: Router, public __oUtilityService: UtilityService,
    @Inject(DOCUMENT) private document: any
  ) { }

  public authenticateUser(getURI: string): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http.get(getURI, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        if (
          this.redirectToUnauthorizePage(error.error)
        ) {
          return throwError(error.error);
        }
        return throwError('Something went wrong!');
      })
    );
  }

  // Correlation id for one login attempt. The same id goes to the auth server (X-RC-Auth-Id header), NGINX and
  // Serilog (AuthId), so a failure can be followed from this console to the server logs.
  getAuthId(): string {
    try {
      let id = sessionStorage.getItem('rc_auth_id');
      if (!id) {
        id = (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(16)).replace(/-/g, '');
        sessionStorage.setItem('rc_auth_id', id);
      }
      return id;
    } catch {
      return 'no-storage';
    }
  }

  // New login attempt = new id. Called each time the unauthorized page opens (first visit, expiry, after logout),
  // so logout -> login is never traced under the previous attempt's id.
  resetAuthId() {
    try {
      sessionStorage.removeItem('rc_auth_id');
    } catch {
      // Storage unavailable: getAuthId() returns 'no-storage'.
    }
  }

  // One place for login/redirect tracing: [RiskCubed][AUTH:<stage>][<authId>] message. Never pass tokens or
  // full URLs with query strings - use hostAndPath() for URLs.
  rcLog(stage: string, message: string, data?: any, level: 'info' | 'warn' | 'error' = 'info') {
    console[level]('[RiskCubed][AUTH:' + stage + '][' + this.getAuthId() + '] ' + message, data !== undefined ? data : '');
  }

  hostAndPath(url: string): string {
    try {
      const u = new URL(url);
      return u.host + u.pathname;
    } catch {
      return '(empty or invalid)';
    }
  }

  getDataByObservableWithoutCredentials(getURI: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    });
    if (environment?.ISDOCKER) {
      headers = headers.set('X-RC-Auth-Id', this.getAuthId());
    }
    let options = { headers: headers, withCredentials: false };
    // var data2 = new Subject<any[]>();

    return this.http.get(getURI, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        if (
          this.redirectToUnauthorizePage(error.error)
        ) {
          return throwError(error.error);
        }

        return throwError('Something went wrong!');
      })
    );
  }

  //returns the data from the API end point
  getDataByObservable(getURI: string): Observable<any[]> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}    
    return this.http.get(getURI, options).pipe(
      map((data: any) => {        
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {        
        this.redirectToUnauthorize(error.error);
        return throwError(this.handleError);
      })
    );
  }

  //returns the data from the API end point
  getDataByObservable2(getURI: string): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = new Object({ headers: headers, withCredentials: true });
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new Object({ headers: headers });
    //}
    return this.http.get(getURI, options);

    //.catch(this.handleError);
  }

  getDataByPromise(getURI: string): Promise<any> {
    return this.__oUtilityService.getDataByPromise(getURI);
  }

  getDataByPromise2(createURI: string, model): Promise<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept:
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
    return this.http
      .post(createURI, model, {
        headers: headers,
        withCredentials: true,
        responseType: ResponseContentType.Blob,
      })
      .pipe(
        map((data: any) => {
          return JSON.parse(JSON.stringify(data));
        }),
        catchError((error) => {
          this.redirectToUnauthorize(error.error);
          return throwError(this.handleError);
        }))
      .toPromise()
      .then((x: any) => x.text)
      .catch(this.handleError);
  }

  //Updates the data for the specific index/ record
  UpdateDataByObservable(
    model: any,
    index: number,
    UpdateURI: string
  ): Observable<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.put(UpdateURI + '/' + index, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }
  // Pass Model as a collection of objects .//Updates the data based on the input collection
  UpdateAllDataByObservable(model: any[], UpdateURI: string): Observable<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http.put(UpdateURI, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      })

    );
  }

  // Pass Model as a collection of objects .//Updates the data based on the input collection
  UpdateAllDataByObservableAndCatchErrorFromAPI(model: any[], UpdateURI: string): Observable<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    return this.http.put(UpdateURI, body, options)
  }

  //Updates the data for the specific index/ record
  UpdateDataByPromise(
    model: any,
    index: number,
    UpdateURI: string
  ): Promise<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http
      .put(UpdateURI, body, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  // Pass Model as a collection of objects .//Updates the data based on the input collection
  UpdateAllDataByPromise(model: any, UpdateURI: string): Promise<any> {
    let body = JSON.stringify(model);
    //let headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'q=0.8;application/json;q=0.9' });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http
      .put(UpdateURI, body, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateAllDataByPromiseWithException(model: any, UpdateURI: string): Promise<any> {
  let body = JSON.stringify(model);
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let options = { headers: headers, withCredentials: true };

  return this.http.put(UpdateURI, body, options)
    .toPromise()
    .then(this.extractData)
    .catch(err => {
      this.handleError(err);
      return Promise.reject(err);
    });
}
  // Add this Promise helper so callers get a rejected Promise on HTTP/model-binding errors
  InsertDataByPromiseWithException(model: any, createURI: string): Promise<any> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, withCredentials: true };

    return this.http.post(createURI, body, options)
      .toPromise()
      .then(this.extractData)
      .catch(err => {
        // Keep existing logging behavior
        try { this.handleError(err); } catch (e) { /* swallow */ }
        // Re-throw so callers' .catch handlers run with the original error
        return Promise.reject(err);
      });
  }
  //Inserts the data
  InsertDataByObservable(model: any, createURI: string): Observable<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http.post(createURI, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }

  InsertDataByPromise(model: any, createURI: string): Promise<any> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http
      .post(createURI, body, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  //Inserts the data  based on the index
  DeleteDataByObservable(index: number, DeleteURI: string): Observable<any> {
    // let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.delete(DeleteURI + '/' + index, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }
  DeleteDataByPromise(index: number, DeleteURI: string): Promise<any> {
    // let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http
      .delete(DeleteURI + '/' + index, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  //   postContactsData( model: Contact, index:number): Observable<Contact> {
  //     console.log("sundar");
  //     console.log(model);
  //     let body = JSON.stringify(model);
  //     let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  //     let options = new Object({ headers: headers });
  //     return this.http.put(this.UpdateApiUrl+'/'+index, body,options)
  //     .pipe(map((data: any) => { return JSON.parse(data); }))
  //     .catch(this.handleError);
  //   }

  // Method used to extract the data in Json format from the  response stream
  private extractData(res: Response): any {
    let body = JSON.parse(JSON.stringify(res));
    return body || [];
  }
  private handleErrorForAuthen(error: any) {
    return throwError(error._body);
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = error?.message
      ? error?.message
      : error?.status
        ? `${error?.status} - ${error?.statusText}`
        : 'Server error';
    console.error(errMsg); // log to console instead
    return throwError(error);
  }
  //Start Sankar Dhayanithi T. 12814 - DataEntity Workflow
  OpenWorkflowForApprovalProcess(
    lDataEntityId: number,
    lDataInstanceId: number,
    lDataEntityTypeId: number,
    ApiUrl: string,
    lDataEntityIssuedTypeId?: number
  ) {
    this.getDataByPromise(
      ApiUrl +
      'api/WorkflowDashBoard/GetWorkflowForApprovalUrl/' +
      lDataEntityId +
      '/' +
      lDataInstanceId +
      '/' +
      lDataEntityTypeId +
      '/' +
      lDataEntityIssuedTypeId
    ).then((Data) => {
      if (Data != null) {
        let url =
          window.location.origin + window.location.pathname + '#' + Data;
        if (url != '') window.open(url, '_blank');
      }
    });
  }

  GetWorkflowAccessForApprovalProcess(
    lDataEntityId: number,
    lDataInstanceId: number,
    lDataEntityTypeId: number,
    ApiUrl: string,
    lDataEntityIssuedTypeId?: number
  ) {
    return this.getDataByPromise(
      ApiUrl +
      'api/WorkflowDashBoard/GetWorkflowForApprovalStatus/' +
      lDataEntityId +
      '/' +
      lDataInstanceId +
      '/' +
      lDataEntityTypeId +
      '/' +
      lDataEntityIssuedTypeId
    ).then((Data) => {
      let bReturn: any;
      if (Data != null) {
        if (Data.length > 0) {
          bReturn = Data;
        }
      }
      return bReturn;
    });
  }
  //End Sankar Dhayanithi T. 12814 - DataEntity Workflow
  //START Rajendra -- FB 20697 -- SSO Message
  public VerifyGetAuthenticate(Data: any, router: any) {
    let bReturn: boolean;
    bReturn = true;
    if (this.redirectToUnauthorizePage(Data) ||
      (typeof Data === 'string' && Data.indexOf('Single Sign-On is enabled') > -1) || (typeof Data === 'string' && Data.indexOf('InvalidSSOResponse') > -1)
    ) {
      bReturn = false;
      if (typeof Data === 'string' && Data.indexOf('Single Sign-On is enabled') > -1)
        router.navigate(['/UnAuthorized/SSOWrongURL']);
      else if (Data.indexOf('InvalidSSOResponse') > -1)
        router.navigate(['/UnAuthorized/InvalidSSOResponse']);
      else router.navigate(['/UnAuthorized/' + Data]);
    }
    return bReturn;
  }
  //END Rajendra -- FB 20697 -- SSO Message
  //returns the data from the API end point by model passing
  //postDataByObservable(model: any, postURI: string): Observable<any[]> {
  //  let body = JSON.stringify(model);
  //  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  //  let options = new Object({ headers: headers, withCredentials: true });
  //  //FB 6060 SSO Integration
  //  //if (environment.SSOEnabled) {
  //  //  options = null;
  //  //  options = new Object({ headers: headers });
  //  //}
  //  return this.http.post(postURI, body, options)
  //    .pipe(map((data: any) => { return JSON.parse(data); }),catchError(this.handleError));
  //}

  postDataByObservable(model: any, postURI: string): Observable<any[]> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}
    return this.http.post(postURI, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }

  validateFileByObservable(postURI: string, model: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders()
    let options = new Object({ headers: headers, withCredentials: true });
    return this.http.post(postURI, model, options);
  }
  

  putDataByObservable(model: any, postURI: string): Observable<any[]> {
    let body = JSON.stringify(model);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    return this.http.put(postURI, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  //Start, FB 31040 Sankar Dhayanithi T., redirect the user to SSO login URL if unauthorized
  RedirectToSSOURL(errorId: any) {
    if (
      this.redirectToUnauthorizePage(errorId)
    ) {
      let errArray: any = errorId.split('~~');
      if (errArray.length > 1) {
        window.location.href = errArray[1];
      }
    }
  }

  RedirectToWindowURL(data: any) {
    window.location.href = data;
  }
  //End, FB 31040 Sankar Dhayanithi T., redirect the user to SSO login URL if unauthorized

  // Silent (hidden-iframe) SSO re-auth: loads the IdP authorize URL with prompt=none in a
  // hidden iframe instead of navigating the browser, so the address bar never changes when
  // the user already has a live session with the identity provider. Resolves 'ok' when the
  // auth cookie was set, 'login_required' when the IdP needs real interaction, or 'timeout'.
  trySilentSso(authorizeUrl: string, authServerOrigin: string, timeoutMs: number = 5000): Promise<string> {
    return new Promise((resolve) => {
      let settled = false;
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';

      const settle = (status: string) => {
        if (settled) {
          return;
        }
        settled = true;
        window.removeEventListener('message', onMessage);
        clearTimeout(timer);
        iframe.parentNode?.removeChild(iframe);
        // ok = auth cookie set; login_required/timeout = user must click Login (visible link).
        this.rcLog('Silent.result', status, undefined, status === 'ok' ? 'info' : 'warn');
        resolve(status);
      };

      const onMessage = (event: MessageEvent) => {
        if (event.origin !== authServerOrigin || event.data?.source !== 'riskcubed-silent-sso') {
          return;
        }
        settle(event.data.status);
      };

      this.rcLog('Silent.start', 'hidden iframe to ' + this.hostAndPath(authorizeUrl) + ', waiting for postMessage from ' + authServerOrigin);
      const timer = setTimeout(() => settle('timeout'), timeoutMs);

      window.addEventListener('message', onMessage);
      iframe.src = authorizeUrl + (authorizeUrl.indexOf('?') > -1 ? '&' : '?') + 'prompt=none';
      document.body.appendChild(iframe);
    });
  }

  getAuthenticate(): Observable<any> {
    var users = new Subject<string>();
    var user: string;
    return this.authenticateUser(
      this.__oUtilityService.GetBasewebAPIURL() + 'api/CommonBase/GetAuthenticate'
    ).pipe(
      map((data) => {
        if (
          this.redirectToUnauthorizePage(data)
        ) {
          // this.oRouter.navigate(['/UnAuthorized/' + user]);
          throw Error(data);
        }

        return data;
      }),
      catchError((error) => {
        throw Error(error);
      })
    );
  }

  redirectToUnauthorize(data: any) {
    if (
      this.redirectToUnauthorizePage(data)
    ) {
      this.oRouter.navigate(['/UnAuthorized/' + data]);
    }
  }


  redirectToUnauthorizePage(data: any) {
    if (
      data === 'Authorization has been denied for this request' || (typeof data === 'string' && data.indexOf('Authorization has been denied') > -1) || data === 'Authorization has been denied because of Token Expiry'
    ) {
      return true
    } else {
      return false;
    }
  }


  // getAuthenticate():Observable<any> {
  //   var users = new Subject<string>();
  //   var user:string;
  //   this.authenticateUser(this.getBasewebAPIURL()+ 'api/CommonBase/GetAuthenticate')
  // .subscribe(
  //   data =>user = data,
  //     error => {
  //       let err: string = error;
  //      throw Error(err);
  //     },
  //     () =>{
  //       if (
  //         user === 'Authorization has been denied for this request' ||
  //         user.indexOf('Authorization has been denied') > -1 ||
  //         user ==='Authorization has been denied because of Token Expiry'
  //       ) {
  //         // this.oRouter.navigate(['/UnAuthorized/' + user]);
  //        throw Error(user);
  //       }

  //       users.next(user);
  //     }
  //   );

  //   return users.asObservable();
  // }



  //Get base web API URL method handler



  getIdentiyBaseURL(document: any): string {
    if (environment?.ISDOCKER) {
      return environment?.RISKCUBEDAUTHSERVERURL + "/";
    }
    if (environment.webapiendpoint.toString() != 'dev') {
      //prod endoint
      let hostname = document.location.origin + '/';
      let documentURL = document.URL; // get the document path
      let urlAarray = documentURL.split('/');
      let baseURL =
        hostname + urlAarray[3] + '/RiskCubedAuthServer/'; // Get the  virtual directory  and append it

      return baseURL;
    } else {
      //dev endpoint
      let baseURL = 'https://localhost:44351/';
      return baseURL;
    }
  }



}

export enum ResponseContentType {
  ArrayBuffer = 'arraybuffer',
  Blob = 'blob',
  Json = 'json',
  Text = 'text',
}

